import { getGameCanvasStandards } from '../../helpers/gameCanvasHelper';
import { roundsInfoStore } from '../../store';
import { lineIntervals } from '../../constants/canvasConfig';
import { isMobile, userSettingsStore } from '@pascal/pascal-core';

const darkPalette = {
  background: '#000000',
  lineFill: '#161616',
  stroke: '#262626',
};

const lightPalette = {
  background: '#e4e4e4',
  lineFill: '#d0d0d0',
  stroke: '#b7b7b7',
};

const bgConfig = {
  get color() {
    const { isDarkModeOn } = userSettingsStore;
    return isDarkModeOn ? darkPalette : lightPalette;
  },
};

const clearCanvas = () => {
  const canvasStandards = getGameCanvasStandards();
  if (!canvasStandards) {
    console.log('Error Canvas standards not available yet.');
    return;
  }
  const { canvas, ctx } = canvasStandards;
  ctx.fillStyle = bgConfig.color.background;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
};

export const drawHorizontalLines = () => {
  const getInitialLinePosition = (axis, interval) => interval - (axis % interval);
  const deviation = isMobile() ? 0.5 : 0;
  const { canvas, ctx } = getGameCanvasStandards();
  const { concentrationPoint } = roundsInfoStore;
  const visibilityStart = (concentrationPoint + deviation) * 10 - canvas.height / 2;
  const initial = -1 * getInitialLinePosition(visibilityStart, lineIntervals.horizontal * 2);

  ctx.strokeStyle = bgConfig.color.stroke; //colors.linesStroke
  ctx.fillStyle = bgConfig.color.lineFill; //colors.lineFill
  ctx.lineWidth = 1;

  for (let i = 0; i < (canvas.height / lineIntervals.horizontal) * 2; i++) {
    const y = initial + i * lineIntervals.horizontal * 2 + ctx.lineWidth / 2;
    ctx.strokeRect(0, y, canvas.width, lineIntervals.horizontal);
    ctx.fillRect(0, y, canvas.width, lineIntervals.horizontal);
  }
};

const drawVerticalLines = () => {
  const { ctx, canvas } = getGameCanvasStandards();
  const { chartStartPoint } = roundsInfoStore;
  const firstLinePosition = 100 - Math.abs(chartStartPoint % 100);

  ctx.strokeStyle = bgConfig.color.stroke;
  ctx.lineWidth = 1;

  for (let i = 0; i < canvas.width / lineIntervals.vertical; i++) {
    const x = firstLinePosition + i * 100;
    ctx.beginPath();
    ctx.moveTo(x, 0);
    ctx.lineTo(x, canvas.height);
    ctx.stroke();
    ctx.closePath();
  }
};

export const backgroundDrawer = () => {
  clearCanvas();
  drawHorizontalLines();
  drawVerticalLines();
};
